module.exports = __webpack_public_path__ + "static/pozyczka-b88b61c0fbd502c8d0318c9bb4e4952d.jpg";